var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fadeMe"},[_c('atom-spinner',{staticClass:"pre-loader",attrs:{"animation-duration":1000,"size":300,"color":_vm.palette.white}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }